import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import MimiFlyGame from './components/MimiFlyGame';
import './App.css';

function App() {
  useEffect(() => {
    // Native app initialization
    if (Capacitor.isNativePlatform()) {
      import('@capacitor/splash-screen').then(({ SplashScreen }) => {
        SplashScreen.hide();
      });
      import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
        StatusBar.setStyle({ style: Style.Dark });
        StatusBar.setBackgroundColor({ color: '#1e1b4b' });
      }).catch(() => {});
    }
  }, []);

  return (
    <div className="App">
      <MimiFlyGame />
    </div>
  );
}

export default App;